import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[firebirdWebAppIntersectionObserver]',
  standalone: false,
})
export class IntersectionObserverDirective implements AfterViewInit, OnDestroy {
  @Output() visible = new EventEmitter<void>();
  private observer: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.visible.emit();
      }
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
